function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgIconReplayFocused = function SvgIconReplayFocused(props) {
  return h("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 131,
    height: 48,
    viewBox: "0 0 131 48"
  }, props), h("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#fff",
    transform: "translate(83)"
  }), h("path", {
    d: "M99.944 16.944a9.55 9.55 0 0 1 3.205-2.178 9.9 9.9 0 0 1 3.85-.766 9.7 9.7 0 0 1 5 1.351A10.1 10.1 0 0 1 115.65 19a9.74 9.74 0 0 1 1.35 5.02 9.63 9.63 0 0 1-1.35 5 10.17 10.17 0 0 1-3.651 3.63 9.93 9.93 0 0 1-8.628.664 10 10 0 0 1-3.064-1.894.41.41 0 0 1-.162-.344.47.47 0 0 1 .122-.342l.805-.805a.52.52 0 0 1 .323-.143.5.5 0 0 1 .363.1 7.5 7.5 0 0 0 2.4 1.492 7.8 7.8 0 0 0 2.842.525 7.65 7.65 0 0 0 3.952-1.068 8 8 0 0 0 2.883-2.883 7.84 7.84 0 0 0 0-7.9 8 8 0 0 0-2.883-2.882A7.64 7.64 0 0 0 107 16.1a7.75 7.75 0 0 0-3.043.606 8.3 8.3 0 0 0-2.56 1.693l2.218 2.218a.43.43 0 0 1 .081.5.44.44 0 0 1-.444.3h-5.767a.47.47 0 0 1-.342-.141.47.47 0 0 1-.141-.342v-5.767a.44.44 0 0 1 .3-.442.43.43 0 0 1 .5.079Z"
  }), h("path", {
    fill: "rgba(255,255,255,0.15)",
    fillRule: "evenodd",
    d: "M2.01 7h66.682a2.01 2.01 0 0 1 2.01 2.01v9.332l6.077 5.408-6.077 5.408v9.335a2.01 2.01 0 0 1-2.01 2.01H2.01A2.01 2.01 0 0 1 0 38.493V9.013A2.01 2.01 0 0 1 2.01 7",
    "data-name": "Path 85"
  }), h("text", {
    fill: "#fff",
    fontFamily: "Barlow-Medium, Barlow",
    fontSize: 16,
    fontWeight: 500,
    letterSpacing: "-.005em",
    transform: "translate(58 29)"
  }, h("tspan", {
    x: -46.352,
    y: 0
  }, "Replay")));
};
export default SvgIconReplayFocused;